import {ExperimentsBag} from '@wix/yoshi-flow-editor';

export const SPECS = {
  PRODUCT_PAGE_BLOCKS_MS4: 'specs.stores.ProductPageBlockMS4',
  PRODUCT_PAGE_BLOCKS_MS3: 'specs.stores.ProductPageBlockMS3',
  UseNewCheckoutInVisitorShippingAndDigitalFlow: 'specs.stores.UseNewCheckoutInVisitorShippingAndDigitalFlow',
  AddOptionsToCartWithKeyInsteadOfTranslation: 'specs.stores.AddOptionsToCartWithKeyInsteadOfTranslation',
  PRODUCT_PAGE_RICH_CONTENT_DESCRIPTION_BLOCKS: 'specs.stores.ProductPageBlocksRico',
  RenderOnDeviceViewChanged: 'specs.stores.ProductPageBlocksRenderOnDeviceViewChanged',
  NonControlledDropdown: 'specs.stores.ProductPageBlocksNonControlledDropdown',
  ShouldInstallSideCart: 'specs.stores.ShouldInstallSideCart',
  ProductPageBlocksNoNavigationDuringInstallation: 'specs.stores.ProductPageBlocksNoNavigationDuringInstallation',
  OptimizeSelectionCalculation: 'specs.stores.OptimizeSelectionCalculation',
  RemoveModifiersFromUserInput: 'specs.stores.RemoveModifiersSelectionIdsFromUserSelections',
  UseMiniCartStylesInSideCart: 'specs.stores.UseMiniCartStylesInSideCart',
  PPOBAddDelayedCapturePropToPaymentMethodsBanner: 'specs.stores.PPOBAddDelayedCapturePropToPaymentMethodsBanner', // TODO:Zeev: close this for now because of issue with payments FYI omri
  EnableStorefrontSubCategories: 'specs.stores.EnableStorefrontSubCategories',
  SendSubcategoriesSeoDataSF: 'specs.stores.SendSubcategoriesSeoDataSF',
  UseFormattedComparePrice: 'specs.stores.ProductPageBlocksUseFormattedComparePrice',
  ShouldCheckDiscountInVariantLevel: 'specs.stores.shouldCheckDiscountVariantLevelPPOB',
  EnableRicoForSeoTags: 'specs.stores.ProductPageBlocksEnableRicoForSeoTags',
  RemoveAddToCartAndCheckoutTrackEvents: 'specs.stores.PPOBRemoveAddToCartAndCheckoutTrackEvents',
  UseStoresCatalogV3PPOB: 'specs.stores.UseStoresCatalogV3PPOB',
  FixNegativeInventoryError: 'specs.stores.ProductPageBlocksFixNegativeInventoryError',
  FixOOSIndicator: 'specs.stores.FixOOSIndicator',
  AddToCartUseStoresViewerScript: 'specs.stores.ProductPageBlocksAddToCartUseStoresViewerScript',
  EnableStoresViewerScriptInViewer: 'specs.stores.EnableStoresViewerScriptInViewer',
  PreloadCarts: 'specs.stores.ProductPageBlocksPreloadCarts',
  EnablePanoramaIntegration: 'specs.stores.ProductPageBlocksEnablePanoramaIntegration',
} as const;

const openedExperimentsForTests: string[] = [
  SPECS.PRODUCT_PAGE_BLOCKS_MS3,
  SPECS.PRODUCT_PAGE_RICH_CONTENT_DESCRIPTION_BLOCKS,
  SPECS.AddOptionsToCartWithKeyInsteadOfTranslation,
  SPECS.NonControlledDropdown,
  SPECS.ShouldInstallSideCart,
  SPECS.OptimizeSelectionCalculation,
  SPECS.RemoveModifiersFromUserInput,
  SPECS.UseMiniCartStylesInSideCart,
  SPECS.PPOBAddDelayedCapturePropToPaymentMethodsBanner,
  SPECS.SendSubcategoriesSeoDataSF,
  SPECS.EnableStorefrontSubCategories,
  SPECS.ShouldCheckDiscountInVariantLevel,
  SPECS.EnableRicoForSeoTags,
  SPECS.RemoveAddToCartAndCheckoutTrackEvents,
  SPECS.UseStoresCatalogV3PPOB,
  SPECS.FixNegativeInventoryError,
  SPECS.FixOOSIndicator,
  SPECS.AddToCartUseStoresViewerScript,
  SPECS.PreloadCarts,
  SPECS.EnablePanoramaIntegration,
];

const openedExperimentsForSled = [
  'specs.thunderbolt.new_responsive_layout_loggedIn',
  'specs.stores.UseSlugAsWarmupDataKey',
  SPECS.NonControlledDropdown,
  SPECS.ShouldInstallSideCart,
  SPECS.OptimizeSelectionCalculation,
  SPECS.RemoveModifiersFromUserInput,
  SPECS.UseMiniCartStylesInSideCart,
  // SPECS.PPOBAddDelayedCapturePropToPaymentMethodsBanner, //TODO:Zeev: close this for now because of issue with payments FYI omri
  SPECS.SendSubcategoriesSeoDataSF,
  SPECS.EnableStorefrontSubCategories,
  SPECS.ShouldCheckDiscountInVariantLevel,
  SPECS.EnableRicoForSeoTags,
  SPECS.RemoveAddToCartAndCheckoutTrackEvents,
  SPECS.UseStoresCatalogV3PPOB,
  SPECS.FixNegativeInventoryError,
  SPECS.FixOOSIndicator,
  SPECS.AddToCartUseStoresViewerScript,
  SPECS.EnableStoresViewerScriptInViewer,
  SPECS.PreloadCarts,
  SPECS.EnablePanoramaIntegration,
];

export const getOpenedExperimentsForTests = (): ExperimentsBag => {
  return openedExperimentsForTests.reduce((prv: any, cur: any) => {
    prv[cur] = 'true';
    return prv;
  }, {});
};

export const getOpenedExperimentsForSled = () => {
  return openedExperimentsForSled.reduce((obj, ex) => {
    obj[ex] = true;
    return obj;
  }, {});
};

export const mapExperimentsToStrings = (experiments: ExperimentsBag) => {
  return Object.entries(experiments).reduce((acc, [key, value]) => {
    acc[key] = value.toString();
    return acc;
  }, {} as Record<string, string>);
};

export const mapExperimentsToBooleans = (experiments: ExperimentsBag) => {
  return Object.entries(experiments).reduce((acc, [key, value]) => {
    if (value === true || value === false) {
      acc[key] = value;
      return acc;
    } else if (value === 'true' || value === 'false') {
      acc[key] = value === 'true' ? true : false;
      return acc;
    }
    return acc;
  }, {} as Record<string, boolean>);
};
